import { render, staticRenderFns } from "./errorApi.vue?vue&type=template&id=23e70533"
import script from "./errorApi.vue?vue&type=script&lang=js"
export * from "./errorApi.vue?vue&type=script&lang=js"
import style0 from "./errorApi.vue?vue&type=style&index=0&id=23e70533&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports